import React, { useEffect, useState } from 'react'
import { TableFromApiCP } from 'submodules/nerit-framework-ui/common/components/table/TableFromApiCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { ButtonGroupCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonGroupCP'
import { ButtonDeleteRecordCP } from 'submodules/nerit-framework-ui/common/components/table/columns/ButtonDeleteRecordCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { AccessControlCP } from 'app/components/access-control/AccessControlCP'
import { PermissionEnum } from 'submodules/nerit-aquatec-sdk/services/auth/authenticate/enums/PermissionEnum'
import { ParameterGroupRequests } from 'submodules/nerit-aquatec-sdk/services/parameter-group/ParameterGroupRequests'
import { ParameterGroupResponseDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/responses/ParameterGroupResponseDTO'
import { ParameterGroupSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/requests/ParameterGroupSearchRequestDTO'
import { ButtonModalParameterGroupCP } from 'modules/collection-performance/components/parameter-group/button-modal-parameter-group/ButtonModalParameterGroupCP'

interface ICPProps {
    shouldLoadData: number
    filters: ParameterGroupSearchRequestDTO
}

export function TableParameterGroupCP(props: ICPProps): JSX.Element {

    const [shouldLoadData, setShouldLoadData] = useState<number>(props.shouldLoadData)
    useEffect(() => setShouldLoadData(props.shouldLoadData), [props.shouldLoadData])

    return (
        <TableFromApiCP<ParameterGroupResponseDTO>
            apiConfig={{
                hasPagination: true,
                requestConfigTP: (filtersDto) => ParameterGroupRequests.search({
                    ...filtersDto, ...props.filters,
                }),
            }}
            appearance={{
                showReloadButton: true,
                wrappedOnCard: true,
                showTotalOnHeader: true,
            }}
            shouldLoadData={shouldLoadData}
            columns={[
                {
                    title: '#',
                    render: (text, record) => record.code,
                    align: 'center',
                },
                {
                    title: 'Nome',
                    render: (text, record) => <TextCP text={record.name} size={'small'} copyable={true}/>,
                },
                {
                    title: 'Total de Parâmetros',
                    render: (text, record) => record.totalFields,
                    align: 'center',
                },
                {
                    render: (text, record) => (
                        <AccessControlCP permission={PermissionEnum.ROLE_ADMIN}>
                            <ButtonGroupCP mode={'separeted'}>
                                <ButtonModalParameterGroupCP
                                    onSave={() => setShouldLoadData(TableUtils.getReloadNumber())}
                                    parameterGroup={record}
                                    buttonSize={'small'}
                                />
                                <ButtonDeleteRecordCP
                                    requestConfigTP={() => ParameterGroupRequests.delete(record.code)}
                                    onDelete={() => setShouldLoadData(TableUtils.getReloadNumber())}
                                />
                            </ButtonGroupCP>
                        </AccessControlCP>
                    ),
                },
            ]}
        />
    )
}
